/* Recommendations are restricted to the current graphic/colour and verified component relation. */
class AlvornMatchingProducts extends HTMLElement {
  connectedCallback() {
    this.refresh = this.refresh.bind(this);
    document.addEventListener('variant:selected', this.refresh);
    document.addEventListener('variant:update', this.refresh);
    document.addEventListener('change', this.refresh);
    queueMicrotask(this.refresh);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:selected', this.refresh);
    document.removeEventListener('variant:update', this.refresh);
    document.removeEventListener('change', this.refresh);
  }

  refresh() {
    if (!this.isConnected) return;
    const picker = [...document.querySelectorAll('variant-picker')].find(candidate =>
      candidate.dataset.productId === this.dataset.productId &&
      !candidate.closest('product-card, quick-add-dialog')
    );
    const selected = kind => {
      const option = picker?.querySelector(`[data-alvorn-option-kind="${kind}"]`);
      return option?.querySelector('input:checked, select')?.value ?? option?.dataset.optionValue ?? '';
    };
    const normalize = value => String(value).trim().toLowerCase().replaceAll('ı', 'i');
    const graphics = new Map([
      ['script grafik', 'script'], ['karakter grafik', 'character'],
      ['karaket grafik', 'character'], ['kanji grafik', 'character'],
    ]);
    const graphic = this.dataset.fixedGraphic || graphics.get(normalize(selected('graphic')));
    const colour = normalize(selected('colour'));
    let active = null;
    for (const group of this.querySelectorAll('[data-matching-look]')) {
      const matches = Boolean(picker && graphic && colour &&
        group.dataset.matchingGraphic === graphic && group.dataset.matchingColour === colour &&
        group.querySelector('[data-alvorn-catalog-card][data-status="live"]'));
      group.hidden = !matches;
      if (matches) active = group;
    }
    this.hidden = !active;
    const summary = this.querySelector('[data-matching-summary]');
    if (summary) summary.textContent = active?.dataset.matchingLabel ?? '';
  }
}

if (!customElements.get('alvorn-matching-products')) {
  customElements.define('alvorn-matching-products', AlvornMatchingProducts);
}
